import styled from "styled-components";

export const ConfirmTnc = styled.div`
  background: #ffffff;
  border-radius: 16px;
  padding: 12px 24px;
  font-size: 14px;
  line-height: 20px;
  color: #4a4a4a;
  font-weight: 400;
  gap: 8px;
`;
